/* eslint-disable no-nested-ternary */
import { getAvatarConfig } from '../../utils/avatarConfig';

interface AvatarProps {
  sender: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Avatar({ sender, size = 'md' }: AvatarProps) {
  const config = getAvatarConfig(sender);
  const sizeClass =
    size === 'sm' ? 'w-8 h-8' : size === 'lg' ? 'w-12 h-12' : 'w-10 h-10';

  return (
    <div
      className={`${sizeClass} rounded border border-gray-300 flex-shrink-0 flex items-center justify-center ${config.backgroundColor || ''}`}
      style={config.customStyle}
    >
      <span className={`text-xs font-semibold ${config.textColor}`}>
        {config.initials}
      </span>
    </div>
  );
}
